// Utility helpers to persist quizzes and flashcards in localStorage
// Stored under key `quizmate_quizzes` and `quizmate_flashcards`

const QUIZ_KEY = 'quizmate_quizzes';
const FLASHCARD_KEY = 'quizmate_flashcards';

export function getQuizzes() {
  try {
    const raw = localStorage.getItem(QUIZ_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error('Failed to parse quizzes from storage', err);
    return [];
  }
}

export function saveQuiz(quizObj) {
  const quizzes = getQuizzes();
  quizzes.push({ ...quizObj, id: Date.now() });
  localStorage.setItem(QUIZ_KEY, JSON.stringify(quizzes));
}

export function getFlashcards() {
  try {
    const raw = localStorage.getItem(FLASHCARD_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error('Failed to parse flashcards', err);
    return [];
  }
}

export function saveFlashcards(deck) {
  const decks = getFlashcards();
  decks.push({ cards: deck, id: Date.now() });
  localStorage.setItem(FLASHCARD_KEY, JSON.stringify(decks));
}
